/* eslint-disable operator-linebreak */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import MUIDataTable from 'mui-datatables';
import { Grid, Link, Tooltip, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import { useLazyQuery, useQuery } from '@apollo/client';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import MUITableLoading from 'components/MUITableLoading/MUITableLoading';
import { EQueryStringKey } from 'services/QueryString/QueryStringService';
import { GET_TITLE_CONTENT_BY_ID } from 'queries/titleContent';
import { setLanguageLabel } from 'pages/labels/languageLabels';
import DrawerContents from '../../../components/DrawerContents';
import PageError from '../../../components/PageError';
import UpdateTitles from '../actions/edit';
import { setStatusLabel } from '../../labels';
import { debounceSearchRender } from '../../../components/DebouncePlugin';
import { StatusType } from '../../../enums/status-type.enum';
import useStyles from '../../../themes/tableStyle';
import { Toast } from '../../../components/Toast';
import { GET_REVIEWERS_WRITERS_TRANSLATORS } from '../../../queries/user';

const GetWriters = () => {
  const { data } = useQuery(GET_REVIEWERS_WRITERS_TRANSLATORS);
  return data;
};
export default function ListTitles({
  loading,
  error,
  titles,
  setTitles,
  total,
  setFilterSearchText,
  page,
  setPage,
  setLimit,
  limit,
  refetchTitles,
  checkHasWriter,
  fieldsNotShow,
  statusCanBeOpened,
}) {
  const location = useLocation();
  const history = useHistory();

  const [selectedTitleId, setSelectedTitleId] = useState('');
  const [selectedTitleStatus, setSelectedTitleStatus] = useState(0);
  const [showDrawer, setShowDrawer] = useState(false);
  const [filterAndSearchPersist, setFilterAndSearchPersist] = useState({
    filterList: [],
    searchText: null,
  });
  const writers = GetWriters();

  const [loadTitleById, { data: titleData }] = useLazyQuery(
    GET_TITLE_CONTENT_BY_ID,
    {
      fetchPolicy: 'network-only',
    },
  );

  const getWriterName = (writerId = '') => {
    let writer;
    if (
      writers &&
      writers.userListByRole &&
      writers.userListByRole.length > 0
    ) {
      writer = writers.userListByRole.find((writer) => writer.id === writerId);
    }
    return writer ? writer.name : '';
  };
  function apendFilterListToColumns(columns, filterList) {
    filterList.forEach((filter, index) => {
      columns[index].options.filterList = filter;
    });
    return columns;
  }
  const classes = useStyles();

  const updateTitlesTable = (page, rowsPerPage) => {
    setPage(page);
    setLimit(rowsPerPage);
  };

  const refreshTitles = () => {
    refetchTitles();
    Toast('Titles updated successfully.');
  };
  const refreshList = () => (
    <Tooltip title="Refresh titles">
      <IconButton aria-label="refresh" onClick={() => refreshTitles()}>
        <Refresh />
      </IconButton>
    </Tooltip>
  );

  const handleOpenEditTitleDrawer = async (title) => {
    const { status: statusTitleHandled, writerId, id: titleId } = title;

    if (checkHasWriter) {
      const {
        data: {
          titlesAsWriter: {
            permissions: { hasWorking },
          },
        },
      } = await refetchTitles();

      if (!hasWorking && statusTitleHandled === StatusType.Approved) {
        checkHasWriter(
          {
            writerId,
            titleId,
            status: statusTitleHandled,
          },
          setSelectedTitleId,
          setSelectedTitleStatus,
          setShowDrawer,
        );
      }
      if (hasWorking && statusTitleHandled === StatusType.Approved) {
        Swal.fire({
          title: 'Alert!',
          text: "You need to finish the content that's currently working",
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      }
    }
    if (statusCanBeOpened.some((status) => status === statusTitleHandled)) {
      setSelectedTitleId(titleId);
      setSelectedTitleStatus(statusTitleHandled);
      setShowDrawer(true);

      const params = new URLSearchParams({
        [EQueryStringKey.TitleId]: titleId,
      });
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }
  };

  const handleRowClick = async (rowData) => {
    const titleId = rowData[0];
    const writerId = rowData[1];
    const status = rowData[2];

    const clickedTitle = {
      id: titleId,
      writerId,
      status,
    };

    handleOpenEditTitleDrawer(clickedTitle);
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
    const params = new URLSearchParams(location.search);
    params.delete(EQueryStringKey.TitleId);
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const sortTitlesTable = (sortOrder) => {
    const { name: field, direction } = sortOrder;

    const clonedTitles = [...titles];

    if (direction === 'asc') {
      clonedTitles.sort((a, b) => {
        return (a[field] || '').localeCompare(b[field] || '');
      });

      setTitles(clonedTitles);
    } else {
      clonedTitles.sort((a, b) => {
        return (b[field] || '').localeCompare(a[field] || '');
      });

      setTitles(clonedTitles);
    }
  };

  useEffect(() => {
    let mounted = true;

    const titleIdQueryString = new URLSearchParams(location.search).get(
      EQueryStringKey.TitleId,
    );

    if (mounted && titleIdQueryString) {
      loadTitleById({
        variables: {
          id: titleIdQueryString,
        },
      });
    }

    return () => (mounted = false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadTitleById]);

  useEffect(() => {
    const titleIdQueryString = new URLSearchParams(location.search).get(
      EQueryStringKey.TitleId,
    );

    if (titleData && titleIdQueryString && statusCanBeOpened.length > 0) {
      const title = titleData.titleContent.titles[0];

      handleOpenEditTitleDrawer(title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleData, statusCanBeOpened]);

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
    sort: true,
    filter: false,
    pagination: true,
    count: total,
    serverSide: true,
    page,
    rowsPerPage: limit,
    customSearchRender: debounceSearchRender(700),
    onRowClick: (rowData) => handleRowClick(rowData),
    searchText: filterAndSearchPersist.searchText ?? undefined,
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changeRowsPerPage':
          updateTitlesTable(tableState.page, tableState.rowsPerPage);
          break;
        case 'changePage':
          updateTitlesTable(tableState.page, tableState.rowsPerPage);
          break;
        case 'sort':
          sortTitlesTable(tableState.sortOrder);
          break;
        case 'search':
          setFilterAndSearchPersist({
            ...filterAndSearchPersist,
            searchText: tableState.searchText,
          });
          setFilterSearchText(tableState.searchText);
          break;
        default:
          break;
      }
    },
  };

  const linkTitle = (value) => {
    return (
      <Link>
        {''}
        {value}
      </Link>
    );
  };

  const columns = [
    {
      name: 'id',
      label: 'Title id to get in row click',
      options: {
        display: false,
        viewColumns: false,
      },
    },
    {
      name: 'writerId',
      label: 'Writer id to get in row click',
      options: {
        display: false,
        viewColumns: false,
      },
    },
    {
      name: 'status',
      label: 'Status number to get in row click',
      options: {
        display: false,
        viewColumns: false,
      },
    },
    {
      name: 'title',
      label: 'TITLE',
      options: {
        display: true,
        customBodyRender: linkTitle,
        empty: true,
        filter: false,
        sort: true,
      },
    },
    {
      name: 'language',
      label: 'LANGUAGE',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (language) => setLanguageLabel(language),
      },
    },
    {
      name: 'writerId',
      label: 'WRITER',
      options: {
        display: fieldsNotShow
          ? !fieldsNotShow.some((field) => field === 'writerId')
          : true,
        customBodyRender: (value) => getWriterName(value),
      },
    },
    {
      name: 'status',
      label: 'STATUS',
      options: {
        display: true,
        setCellHeaderProps: () => ({ className: classes.statusLabel }),

        customBodyRender: (value) => setStatusLabel(value),
      },
    },
    {
      name: 'comments',
      label: 'COMMENTS',
      options: {
        display: false,
      },
    },
    {
      name: 'suggestedKeywords',
      label: 'SUGGESTED KEYWORDS',
      options: {
        display: false,
      },
    },
    {
      name: 'researchLinks',
      label: 'RESEARCH LINKS',
      options: {
        display: false,
      },
    },
    {
      name: 'countries',
      label: 'COUNTRIES',
      options: {
        display: false,
      },
    },
    {
      name: 'publishPost',
      label: 'PUBLISH POST',
      options: {
        display: true,
        filter: false,
        sort: true,
        customBodyRender(publishPost) {
          return publishPost
            ? moment(publishPost).utc().format('YYYY-MM-DD')
            : '';
        },
      },
    },
    {
      name: 'deadline',
      label: 'DEADLINE',
      options: {
        display: true,
        filter: false,
        sort: true,
        customBodyRender(deadline) {
          return deadline ? moment(deadline).utc().format('YYYY-MM-DD') : '';
        },
      },
    },
  ];

  return (
    <>
      <DrawerContents
        title="Edit Titles"
        statusDrawer={showDrawer}
        setStatusDrawer={setShowDrawer}
        onCloseDrawer={handleCloseDrawer}
      >
        <UpdateTitles
          titleId={selectedTitleId}
          titleStatus={selectedTitleStatus}
          setShowDrawer={setShowDrawer}
          refetchContentList={refetchTitles}
        />
      </DrawerContents>
      {loading ? (
        <MUITableLoading
          columns={['TITLE', 'LANGUAGE', 'STATUS', 'PUBLISH POST', 'DEADLINE']}
        />
      ) : error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <MUIDataTable
              title={refreshList()}
              data={titles}
              options={options}
              columns={apendFilterListToColumns(
                columns,
                filterAndSearchPersist.filterList,
              )}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
